module.exports = __webpack_public_path__ + "static/media/pen-ryn.08d9592c.png";